function initArcadeParticles(containerId, particleColor) {
  tsParticles.load(containerId, {
    fullScreen: {
    enable: false // 🚨 THIS STOPS IT FROM TAKING THE WHOLE PAGE
  },
  detectRetina: false,
 
    particles: {
      number: { value: 100 },
      color: { value: particleColor },
      shape: { type: "square" },
      opacity: {
        value: 1,
        animation: {
          enable: true,
          speed: 1,
          minimumValue: 0.1,
          sync: false
        }
      },
      size: {
        value: 4,
        random: { enable: true, minimumValue: 2 }
      },
      move: {
        enable: true,
        speed: 1,
        direction: "none",
        straight: true,
        outModes: { default: "out" }
      },
      shadow: {
        enable: true,
        color: "#FF4FA3",
        blur: 0,
        offset: { x: 2, y: 2 }
      }
    },
    interactivity: {
      events: {
        onHover: { enable: true, mode: "repulse" }
      },
      modes: {
        repulse: { distance: 100 }
      }
    },
    detectRetina: false
  });
}
